import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationCircledIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 15.6 15.6",
	style: { enableBackground: "new 0 0 15.6 15.6" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.exclamation-circled-icon-st1{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;}\n	.exclamation-circled-icon-st2{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n	.exclamation-circled-icon-st3{fill:currentColor;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "exclamation-circled-icon-st1",
			d: "M7.8,14.6c3.7,0,6.8-3,6.8-6.8c0-3.7-3-6.8-6.8-6.8C4.1,1,1,4,1,7.8C1,11.5,4.1,14.6,7.8,14.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "exclamation-circled-icon-st2",
			d: "M7.8,4.4v3.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "exclamation-circled-icon-st3",
			d: "M7.8,11.7c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8S7,10.5,7,10.9C7,11.4,7.3,11.7,7.8,11.7z"
		})
	] })]
});
export default SvgExclamationCircledIcon;
